import $ from '@vaersaagod/tools/Dom';
import Flickity from 'flickity';
import Viewport from '@vaersaagod/tools/Viewport';

export default el => {
    const dom = $(el);
    const wrapper = dom.find('[data-items]').get(0);
    const prev = dom.find('[data-prev]');
    const next = dom.find('[data-next]');
    let flkty = null;

    const init = () => {
        flkty = new Flickity(wrapper, {
            wrapAround: true,
            dragThreshold: 10,
            prevNextButtons: false,
            pageDots: true,
            resize: true,
            cellSelector: '[data-item]',
            cellAlign: Viewport.width >= 1200 ? 'center' : 'left'
        });
        prev.on('click', () => {
            flkty.previous();
        });

        next.on('click', () => {
            flkty.next();
        });
        flkty.resize();

        flkty.on('dragStart', () => {
            document.ontouchmove = e => e.preventDefault();
        });
        flkty.on('dragEnd', () => {
            document.ontouchmove = () => true;
        });

        Viewport.on('breakpoint', e => {
            flkty.options.cellAlign = e.detail.current.size >= 1200 ? 'center' : 'left';
            flkty.resize();
        });
    };

    const destroy = () => {
        flkty.destroy();
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FrontpageCarousel.js